// employee/reducers.ts
const initialState = {
    getCustomerData: [],
    getCustomerCount: null,
    createCustomerData: null,
    updateCustomerData: null,
    getCustomerMetaMessage: null,
    getCustomerSuccess: false,
    getCustomerFailure: false,
    createCustomerSuccess: false,
    createCustomerFailure: false,
    updateCustomerSuccess: false,
    updateCustomerFailure: false,
    deleteCustomerSuccess: false,
    deleteCustomerFailure: false,
};

export default function CustomerReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_CUSTOMER_SUCCESS': {
            return {
                ...state,
                getCustomerSuccess: true,
                getCustomerData: action.payload?.data?.data?.data,
                getCustomerCount:action.payload?.data?.data?.meta?.total,
                getCustomerFailure: false,
            };
        }
        case 'GET_CUSTOMER_FAILURE': {
            return {
                ...state,
                getCustomerFailure: true,
                getCustomerMetaMessage: action.payload?.data?.data?.meta?.message,
                getCustomerSuccess: false,
            };
        }
        case 'RESET_GET_CUSTOMER': {
            return {
                ...state,
                getCustomerSuccess: false,
                getCustomerFailure: false,
                getCustomerData: [],
                getCustomerMetaMessage: null,
            };
        }

        case 'CREATE_CUSTOMER_SUCCESS': {
            return {
                ...state,
                createCustomerSuccess: true,
                createCustomerData: action.payload?.data?.data?.data,
                getCustomerMetaMessage: action.payload?.data?.data?.meta?.message,
                createCustomerFailure: false,
            };
        }
        case 'CREATE_CUSTOMER_FAILURE': {
            return {
                ...state,
                createCustomerFailure: true,
                getCustomerMetaMessage: action.payload?.data?.data?.meta?.message,
                createCustomerSuccess: false,
            };
        }
        case 'RESET_CREATE_CUSTOMER': {
            return {
                ...state,
                createCustomerSuccess: false,
                createCustomerFailure: false,
                createCustomerData: null,
                getCustomerMetaMessage: null,
            };
        }

        case 'UPDATE_CUSTOMER_SUCCESS': {
            return {
                ...state,
                updateCustomerSuccess: true,
                updateCustomerData: action.payload?.data?.data?.data,
                getCustomerMetaMessage: action.payload?.data?.data?.meta?.message,
                updateCustomerFailure: false,
            };
        }
        case 'UPDATE_CUSTOMER_FAILURE': {
            return {
                ...state,
                updateCustomerFailure: true,
                getCustomerMetaMessage: action.payload?.data?.data?.meta?.message,
                updateCustomerSuccess: false,
            };
        }
        case 'RESET_UPDATE_CUSTOMER': {
            return {
                ...state,
                updateCustomerSuccess: false,
                updateCustomerFailure: false,
                updateCustomerData: null,
                getCustomerMetaMessage: null,
            };
        }

        case 'DELETE_CUSTOMER_SUCCESS': {
            return {
                ...state,
                deleteCustomerSuccess: true,
                getCustomerMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteCustomerFailure: false,
            };
        }
        case 'DELETE_CUSTOMER_FAILURE': {
            return {
                ...state,
                deleteCustomerFailure: true,
                getCustomerMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteCustomerSuccess: false,
            };
        }
        case 'RESET_DELETE_CUSTOMER': {
            return {
                ...state,
                deleteCustomerSuccess: false,
                deleteCustomerFailure: false,
                getCustomerMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
